function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M33.0469 0C30.605 0 28.3663 0.773789 26.3929 2.29992C24.5011 3.76304 23.2415 5.62658 22.5 6.98168C21.7585 5.62649 20.4989 3.76304 18.6071 2.29992C16.6337 0.773789 14.395 0 11.9531 0C5.13879 0 0 5.57376 0 12.9651C0 20.9503 6.41101 26.4137 16.1164 34.6845C17.7645 36.089 19.6327 37.6811 21.5743 39.379C21.8303 39.6032 22.159 39.7266 22.5 39.7266C22.841 39.7266 23.1697 39.6032 23.4257 39.3791C25.3675 37.6809 27.2355 36.0889 28.8846 34.6836C38.589 26.4137 45 20.9503 45 12.9651C45 5.57376 39.8612 0 33.0469 0Z",
  fill: "black"
});

var SvgHeart = function SvgHeart(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 40,
    viewBox: "0 0 45 40",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHeart, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/heart.ae203418.svg";
export { ForwardRef as ReactComponent };